<template>
  <modal-cont v-if="modal.show">
    <h3 v-if="modal.name" class="name">
      {{ modal.name }}
    </h3>
    <div v-if="modal.text" class="text" :class="{ wicon: modal.icon }">
      <icon v-if="modal.icon" class="icon" :name="modal.icon"/>
      {{ modal.text }}
    </div>
    <row v-if="modal.actions" class="actions-row">
      <column v-for="action in modal.actions" :xs="12 / modal.actions.length" :key="action.label">
        <btn :class="action.theme + ' sm act'" @click="process(action.action)">{{ action.label }}</btn>
      </column>
    </row>
    <slot/>
  </modal-cont>
</template>

<script>
import { getters } from '../../utils'

let interval

export default {
  computed: getters('modal'),
  methods: {
    process(actionName) {
      if (typeof actionName === 'function') {
        actionName(this)
      } else if (this[actionName] !== 'undefined') {
        this[actionName]()
      }
    },
    confirm() {
      this.modal.confirm()
      this.close()
    },
    close() {
      this.modal.show = false
    },
    startInterval() {
      if (typeof interval === 'undefined' && this.modal.show) {
        interval = setInterval(() => {
          const mod = this.modal
          if (mod && mod.fadeOut && mod.fadeOut > 0) {
            mod.fadeOut -= 1000
            if (mod.fadeOut <= 0) {
              this.modal.show = false
              interval = clearInterval(interval)
            }
          }
        }, 1000)
      }
    },
  },
  watch: {
    'modal.show'(val) {
      this.startInterval()
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

</style>



// WEBPACK FOOTER //
// src/views/components/globals/Modal.vue